import { isEmpty, reject } from "lodash";
// types
import TApplicationDocument from "@/cms/types/TApplicationDocument";
// enums
import EResourceType from '@/cms/enums/EResourceType';
import ESizeType from "@/cms/enums/ESizeType";
// types
import TResource from '@/cms/types/TResource';


type TApplicationDocumentSelector = {

    resources?: TResource[];
    
    resourceType?: EResourceType;
    sizeType?: ESizeType;

    type?: "find"|"filter";

    disableDeriveds?: boolean;

}

const _find = ( props:Readonly<TApplicationDocumentSelector> ) => {

    let resource:TResource|undefined;
    if ( props.sizeType !== null && props.sizeType !== undefined ) {
        resource = props.resources?.find((item) => item.resourceTypeId === props.resourceType && item.applicationDocument.sizeType === props.sizeType);
    } else {
        resource = props.resources?.find((item) => item.resourceTypeId === props.resourceType);
    }

    const applicationDocument = resource?.applicationDocument;
    const derived = resource?.applicationDocument?.deriveds?.[0];
    
    if ( derived && !isEmpty(derived) && !props.disableDeriveds ) return derived as any;
    else if ( applicationDocument && !isEmpty(applicationDocument) ) return applicationDocument as any;

    return null as any;
}

const _filter = ( props:Readonly<TApplicationDocumentSelector> ) => {

    let resources:TResource[]|undefined;
    if ( props.sizeType !== null && props.sizeType !== undefined ) {
        resources = props.resources?.filter((item) => item.resourceTypeId === props.resourceType && item.applicationDocument.sizeType === props.sizeType);
    } else {
        resources = props.resources?.filter((item) => item.resourceTypeId === props.resourceType);
    }

    const applicationDocuments = reject(resources?.map((item) => item.applicationDocument as TApplicationDocument), isEmpty);
    const deriveds = reject(resources?.map((item) => item.applicationDocument.deriveds?.[0]), isEmpty);

    if ( deriveds && !isEmpty(deriveds) && !props.disableDeriveds ) return deriveds as any;
    else if ( applicationDocuments && !isEmpty(applicationDocuments) ) return applicationDocuments as any;

    return null as any;
}

const ApplicationDocumentSelector = <T>( props:TApplicationDocumentSelector ): T => {

    if ( !isEmpty(props.resources) ) {

        if ( props.type === "find" ) {

            return _find(props);

        } 
        else if ( props.type === "filter" ) {

            return _filter(props);

        }

    }

    return null as any;

}


export type {
    TApplicationDocumentSelector
}
export default ApplicationDocumentSelector;
